"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAnswerWithType = exports.isValidAnswer = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const validValue = (t) => !!`${t || t === 0 ? t : ''}`;
const validDate = (t) => (0, moment_timezone_1.default)(t).isValid();
const isValidAsDateTimeAnswer = (a, rule) => {
    return validDate(a.value) && rule.preventFutureDate ? (0, moment_timezone_1.default)(a.value).isBefore((0, moment_timezone_1.default)()) : true;
};
const isValidAsIssueAnswer = (a) => {
    return true; //!!a.value && (!!a.issue || !!a.issueId)
};
const isValidAsNumberAnswer = (a, rule) => {
    var _a, _b;
    let precisionValue = 0;
    const newV = parseFloat(a.value);
    if (!isNaN(newV)) {
        if (Math.floor(newV) === newV) {
            precisionValue = 0;
        }
        else {
            precisionValue = ((_b = (_a = newV === null || newV === void 0 ? void 0 : newV.toString()) === null || _a === void 0 ? void 0 : _a.split('.')[1]) === null || _b === void 0 ? void 0 : _b.length) || 0;
        }
        const hasDefaultMinMaxValue = rule.maxValue === 10 && rule.minValue === 0;
        const hasNoMaxValue = (!rule.maxValue && rule.maxValue !== 0) || hasDefaultMinMaxValue;
        const hasNoMinValue = (!rule.minValue && rule.minValue !== 0) || hasDefaultMinMaxValue;
        return !((!hasNoMaxValue && newV > rule.maxValue) ||
            (!hasNoMinValue && newV < rule.minValue) ||
            (rule.precisionValue && precisionValue > rule.precisionValue));
    }
    return false;
};
const isValidAnswer = (a, q, rule) => {
    return (0, exports.isValidAnswerWithType)(a, q.type, rule);
};
exports.isValidAnswer = isValidAnswer;
const isValidAnswerWithType = (a, type, rule) => {
    if (!!a && !a.invalid) {
        if (!!a.notApplicable)
            return true;
        switch (type) {
            case FormQuestionType_1.default.DATETIME:
                return validValue(a.value) && isValidAsDateTimeAnswer(a, rule);
            case FormQuestionType_1.default.ISSUE:
                return isValidAsIssueAnswer(a);
            case FormQuestionType_1.default.NUMBER:
                return isValidAsNumberAnswer(a, rule);
            default:
                return validValue(a.value) || !!a.comment || !!a.photos;
        }
    }
    return false;
};
exports.isValidAnswerWithType = isValidAnswerWithType;
exports.default = exports.isValidAnswer;
